<template>
  <div class="content-group">
    <div
      v-for="(groupItem, key) in field.items"
      :key="key"
      class="content-group-wrapper"
    >
      <configField
        :id="id"
        :category="category"
        v-if="groupItem.type === 'config'"
        :field="getFieldData(groupItem.id)"
        :value="getConfigValue(groupItem.id)"
        :parentField="parentField"
        :hideLabel="
          groupItem.configHideLabel !== undefined
            ? groupItem.configHideLabel
            : true
        "
        :isTemplate="isTemplate"
        :class="`content-group-${getType(groupItem.id)}`"
      />
      <div
        v-if="groupItem.type === 'content'"
        v-html="groupItem.content"
        class="content"
      />
      <group
        :id="id"
        :category="category"
        v-if="groupItem.type === 'group'"
        :field="groupItem"
        :parentField="parentField"
        hideLabel
        :isTemplate="isTemplate"
      />
    </div>
    <tooltip :text="tooltip" />
    <helpIcon v-if="helpContent" :content="helpContent" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import configField from "@/components/config-field";
import group from "@/components/config-tab/group";

import getFieldData from "@/util/getFieldData";

import tooltip from "@/components/tooltip";

import helpIcon from "@/components/help-icon";

export default {
  name: "ContentGroup",
  components: {
    configField,
    group,
    tooltip,
    helpIcon,
  },
  props: {
    category: {
      type: String,
    },
    field: {
      type: Object,
    },
    parentField: {
      type: String,
    },
    id: {
      type: String,
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
    },
    helpContent: {
      type: String,
    },
  },
  computed: {
    fieldList() {
      const fieldData =
        this.configTemplate && this.configTemplate[this.category];
      return fieldData && fieldData.AvailableFieldList;
    },
    ...mapGetters({
      mergedConfig: "getMergedConfig",
      configTemplate: "getConfigTemplate",
      configVisibility: "getConfigVisibility",
    }),
  },
  methods: {
    getConfigValue(id) {
      let configValue =
        this.mergedConfig[this.id] && this.mergedConfig[this.id][this.category];
      if (this.parentField !== undefined) {
        configValue =
          configValue &&
          this.mergedConfig[this.id][this.category][this.parentField] &&
          this.mergedConfig[this.id][this.category][this.parentField][id];
      } else {
        configValue =
          configValue && this.mergedConfig[this.id][this.category][id];
      }
      return configValue;
    },
    getFieldData(id) {
      return getFieldData(this.fieldList, id);
    },
    getType(id) {
      const data = this.getFieldData(id);
      return data ? data.Type : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-group {
  display: none;
  flex-wrap: wrap;
  align-items: center;
  gap: $qvo-spacing-8;
  &:has(.config-field, .content) {
    // only display content-group blocks that have config items inside
    display: flex;
  }
  .content-group-wrapper:has(.content-group-checkbox, .group) {
    flex-basis: 100%;
  }
  .group {
    display: flex;
    align-items: center;
    gap: $qvo-spacing-8;
  }
  &::v-deep {
    .label p {
      // body-2 styles
      font-size: 0.875rem;
      font-weight: 350;
      line-height: 1.4;
    }
  }
}
</style>